export default {
  state: {
    uploadState: false,
    uploadData: {}
  },
  getters: {
    // getUploadState(state) {
    //   return state.uploadState
    // }
    // getUploadData(state) {
    //   return state.uploadData
    // }
  },
  mutations: {
    // startUpload(state, flag) {
    //   state.uploadState = flag
    // },
    // async setUploadData(state, uploadData) {
    //   state.uploadData = uploadData
    // }
  },
  actions: {}
}
